export default "/memento-mori/assets/cd48057d9cf1a8e22cbfb7f797a025b3.mp3";